import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import car from './modules/car'
import files from './modules/files'
import boxes from './modules/boxes'
import orders from './modules/orders'
import search from './modules/search'
import reports from './modules/reports'
import pickup from './modules/pickup'
import materiales from './modules/materiales'
import orderGeneral from './modules/orderGeneral'
import rangeBoxGeneral from './modules/rangeBoxGeneral'
import firstPickup from './modules/firstPickup'
import imports from './modules/imports'
import low from "./modules/low";
import inquiries from "./modules/inquiries";
import disposals from "./modules/disposals";
import itemIncome from "./modules/itemIncome";

Vue.use(Vuex)

const store = new Vuex.Store({

  modules: {
    auth,
    car,
    files,
    boxes,
    orders,
    search,
    reports,
    pickup,
    materiales,
    orderGeneral,
    rangeBoxGeneral,
    firstPickup,
    imports,
    low,
    inquiries,
    disposals,
    itemIncome
  }

})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js